import { DEFAULT_LOAN_ACTION_TARGET_TYPE } from 'constants/loanActions';

import { LOAN_ACTIONS_ACTION_TYPE } from '../actions';

const initialState = DEFAULT_LOAN_ACTION_TARGET_TYPE;

const loanActionsTargetReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_ACTIONS_ACTION_TYPE.SET_LOAN_ACTIONS_TARGET_TYPE:
      return payload || initialState;

    default:
      return state;
  }
};

export default loanActionsTargetReducer;
